import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Icon,
  Input,
  Table,
  Button,
  Select,
  message,
  Spin,
  Checkbox,
  Tooltip,
} from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import Pagination from "../../components/pagination";
import EditAgencyModal from "./edit-agency-modal";
import EditUserModal from "./edit-user-modal";
import Cookies from "js-cookie";
import { Translate } from "react-translated";
import { debounceQuery } from "../../utils/Constants";
import DeleteInActiveModal from "./delete-inactive-modal"
import { INACTIVE_AGENCIES_API_URL } from "../../utils/Api_enums";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';

const Option = Select.Option;

class InactiveAgencies extends Component {
  state = {
    loading: true,
    agencies: [],
    page: 1,
    total_pages: 0,
    agency: {},
    edit_agency_modal: false,
    delete_agency_modal: false,
    search: "",
    search_address: "",
    current_agency_index: null,
    hideTestAgencies: false,
  };
  componentDidMount = () => {
    this.loadAllAgencies();
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.location.state !== this.props.location.state) {
      this.refreshInfo();
    }
  };

  loadAllAgencies = () => {
    this.loadAgencies(this.state.page, 1);
  };

  clearSearch = () => {
    this.setState({ search: "", page: 1 });
  };


  loadAgencies = (page, isinitial) => {
    // const filters = [];
    const searchAddress = this.state.search_address || "";
    // const withoutAbbreviation = searchAddress.split("+")[1] || "";
    const onlyAbbrevation = searchAddress.split("+")[0] || "";
    // filters.push({ name: "active", op: "==", val: 0 });

    const searchPurify = F.removeSpecialCharactersFromString(this.state.search);

    let api = `${INACTIVE_AGENCIES_API_URL}?page=${page}`;
    if (onlyAbbrevation) {
      api += `&address=${onlyAbbrevation}`;
    }
    if (searchPurify.trim().length > 0) {
      api += `&search_word=${encodeURIComponent(searchPurify)}`;
    }
    if (this.state.hideTestAgencies) {
      // api += `&test=${this.state.hideTestAgencies ? 1 : 0}`;
      api += `&test=0`;
    }

    // if (searchPurify.trim().length >= 0) {
    //   filters.push({
    //     or: [
    //       {
    //         name: "name",
    //         op: "like",
    //         val: encodeURIComponent("%" + searchPurify + "%"),
    //       },
    //       {
    //         name: "primary",
    //         op: "has",
    //         val: {
    //           name: "first_name",
    //           op: "like",
    //           val: encodeURIComponent("%" + searchPurify + "%"),
    //         },
    //       },
    //       {
    //         name: "primary",
    //         op: "has",
    //         val: {
    //           name: "last_name",
    //           op: "like",
    //           val: encodeURIComponent("%" + searchPurify + "%"),
    //         },
    //       },
    //     ],
    //   });
    // }

    // if (onlyAbbrevation !== "" && isinitial !== 0) {
    //   filters.push({
    //     name: "address",
    //     op: "like",
    //     val: encodeURIComponent("%" + onlyAbbrevation + "%"),
    //   });
    // }

    // const api =
    //   "/api/admin_feed?page=" +
    //   page +
    //   '&q={"filters":' +
    //   JSON.stringify(filters) +
    //   "}";
    // this.setState({ loading: true });
    // axios.get(api).then((res) => {
    //   this.setState({
    //     loading: false,
    //     agencies: res.data.objects,
    //     page: res.data.page,
    //     total_pages: res.data.total_pages,
    //     ...(isinitial === 0 && { allAgencies: res.data.objects }),
    //   });
    // });

    this.setState({ loading: true });
    axios
      .get(api)
      .then((res) => {

        console.log("API Response:", res.data);

        if (res.data && res.data.agencies) {
          this.props.setState({ total_agencies: res.data.total })
          this.setState(
            {
              loading: false,
              agencies: res.data.agencies,
              page: res.data.current_page,
              total_pages: res.data.pages,
              ...(isinitial === 0 && { allAgencies: res.data.agencies }),
            },
            () => {

              console.log("State after update:", this.state);
            }
          );
        } else {
          console.error("Unexpected API response structure:", res.data);
          this.setState({
            loading: false,
            agencies: [],
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching inactive agencies:", error);
        this.setState({
          loading: false,
          agencies: [],
        });
      });
  };
  updateAgency = (name, value) => {
    const { agencies, current_agency_index } = this.state;
    agencies[current_agency_index][name] = value;
    // this.setState({ agencies });

    if (name === 'active') {
      agencies[current_agency_index][name] = Boolean(value);
    } else {
      agencies[current_agency_index][name] = value;
    }
    // Also update the agency in state!
    this.setState({
      agencies,
      agency: { ...agencies[current_agency_index] }
    });
  };

  onSearchAgency = (event) => {
    this.setState(
      {
        search: event.target.value,
        // search_address: "",
      },
      () => debounceQuery(this.loadAgencies.bind(this, 1))
    );
  };

  refreshInfo = () => {
    localStorage.removeItem("agGridColumnState");

    if (this.state.columnApi) {
      this.state.columnApi.resetColumnState();
      this.state.columnApi.resetColumnGroupState();
    }

    this.setState({ search: "", search_address: "", hideTestAgencies: false }, () => {
      this.loadAllAgencies();
    });
  };


  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      columnApi: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }

  saveState = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }

  render() {
    const { loading, agencies, page, total_pages } = this.state;

    const states = [
      { name: "Alabama", value: "AL" },
      { name: "Alaska", value: "AK" },
      { name: "Arizona", value: "AZ" },
      { name: "Arkansas", value: "AR" },
      { name: "California", value: "CA" },
      { name: "Colorado", value: "CO" },
      { name: "Connecticut", value: "CT" },
      { name: "Delaware", value: "DE" },
      { name: "District Of Columbia", value: "DC" },
      { name: "Florida", value: "FL" },
      { name: "Georgia", value: "GA" },
      { name: "Hawaii", value: "HI" },
      { name: "Idaho", value: "ID" },
      { name: "Illinois", value: "IL" },
      { name: "Indiana", value: "IN" },
      { name: "Iowa", value: "IA" },
      { name: "Kansas", value: "KS" },
      { name: "Kentucky", value: "KY" },
      { name: "Louisiana", value: "LA" },
      { name: "Maine", value: "ME" },
      { name: "Maryland", value: "MD" },
      { name: "Massachusetts", value: "MA" },
      { name: "Michigan", value: "MI" },
      { name: "Minnesota", value: "MN" },
      { name: "Mississippi", value: "MS" },
      { name: "Missouri", value: "MO" },
      { name: "Montana", value: "MT" },
      { name: "Nebraska", value: "NE" },
      { name: "Nevada", value: "NV" },
      { name: "New Hampshire", value: "NH" },
      { name: "New Jersey", value: "NJ" },
      { name: "New Mexico", value: "NM" },
      { name: "New York", value: "NY" },
      { name: "North Carolina", value: "NC" },
      { name: "North Dakota", value: "ND" },
      { name: "Ohio", value: "OH" },
      { name: "Oklahoma", value: "OK" },
      { name: "Oregon", value: "OR" },
      { name: "Pennsylvania", value: "PA" },
      { name: "Rhode Island", value: "RI" },
      { name: "South Carolina", value: "SC" },
      { name: "South Dakota", value: "SD" },
      { name: "Tennessee", value: "TN" },
      { name: "Texas", value: "TX" },
      { name: "Utah", value: "UT" },
      { name: "Vermont", value: "VT" },
      { name: "Virginia", value: "VA" },
      { name: "Washington", value: "WA" },
      { name: "West Virginia", value: "WV" },
      { name: "Wisconsin", value: "WI" },
      { name: "Wyoming", value: "WY" },
    ];

    const columnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: 'Agency',
        field: 'name',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Agency'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'name',
        }),
        cellRendererFramework: (params) => (
          <React.Fragment>
            <span>{params.data.name}</span>
            {params.data.test === 1 && (
              <Tooltip
                placement="top"
                title={<Translate text={'Test Agency'} />}
                getPopupContainer={() => document.querySelector('.ag-theme-material')}
              >
                <span style={{ color: 'red' }}> (TA)</span>
              </Tooltip>
            )}
          </React.Fragment>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'First Name',
        field: 'first_name',
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['First Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'first_name',
        }),
        valueGetter: params => (params.data.primary && params.data.primary.first_name) ? params.data.primary.first_name : '',
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Last Name',
        field: 'last_name',
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Last Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'last_name',
        }),
        valueGetter: params => (params.data.primary && params.data.primary.last_name) ? params.data.primary.last_name : '',
      },
      {
        headerClass: 'custom-ag-header',
        headerName: '',
        field: 'actions',
        minWidth: 350,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Actions'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'actions',
        }),
        sortable: false,
        cellRendererFramework: (params) => {
          const i = agencies.findIndex(a => a.id === params.data.id);
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, height: '100%' }}>
              <Button
                className="borderRadius-28"
                onClick={() => {
                  this.setState({
                    agency: params.data,
                    edit_agency_modal: true,
                    current_agency_index: i,
                  });
                }}
              >
                <Icon type="edit" /> Edit Agency
              </Button>
              <Button
                type="danger"
                className="borderRadius-28"
                style={{ marginLeft: 10 }}
                onClick={() => {
                  this.setState({
                    agency: params.data,
                    delete_agency_modal: true,
                    current_agency_index: i,
                  });
                }}
              >
                <Icon type="delete" /> Delete Agency
              </Button>
            </div>
          );
        },
      },
    ];

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon type="team" style={{ marginRight: 10, color: "#1890ff" }} />
              Inactive Agencies
            </div>
          }
          className="tableCard"
          loading={loading}
          extra={
            <div className="agency-filters">
              <Row gutter={16} justify="space-between" align="middle">
                <Col flex="1 1 180px" className="agency-col">
                  <Input
                    placeholder="Search Agency"
                    className="borderRadius-28"
                    onChange={(e) => this.onSearchAgency(e)}
                    value={this.state.search}
                    style={{ width: "200px" }}
                    onPressEnter={() => {
                      const searchPurify = F.removeSpecialCharactersFromString(
                        this.state.search
                      );

                      if (searchPurify.trim().length > 0) {
                        if (searchPurify.trim().length >= 0) {
                          this.loadAgencies(1);
                        }
                      }
                    }}
                  />
                  {this.state.search ? (
                    <Icon
                      type="close"
                      onClick={() => this.onSearchAgency({ target: { value: "" } })}
                      className="icon-style"
                    />
                  ) : (
                    <Icon
                      type="search"
                      className="icon-style"
                    />
                  )}
                </Col>
                <Col flex="1 1 180px" className="agency-col">
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select State"
                    className='custom-select'
                    style={{
                      width: '200px',
                      fontSize: '13px',
                      backgroundColor: 'white',
                      borderRadius: '20px',
                      fontWeight: 500
                    }}
                    value={this.state.search_address || []}
                    onChange={(value) => {
                      this.setState(
                        {
                          search_address: value,
                          //  search: ""
                        },
                        () => {
                          this.loadAgencies(1);
                        }
                      );
                    }}
                  >
                    {states.map((item, i) => (
                      <Option value={item.value} key={i} style={{ fontSize: '13px' }}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col className="agency-col">
                  <Checkbox
                    className="hide-test-agencies-checkbox"
                    onChange={(e) => {
                      const hideTestAgencies = e.target.checked;
                      this.setState({ hideTestAgencies }, () => {
                        this.loadAgencies(1);
                      })
                    }
                    }
                    checked={this.state.hideTestAgencies}
                  >
                    <Translate text="Hide Test Agencies" />
                  </Checkbox>
                </Col>
                <Col flex="none" className="agency-col">
                  <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <Button
                      type="primary"
                      className="bg-164897"
                      style={{ borderRadius: 10 }}
                      onClick={this.refreshInfo}
                    >
                      <Icon type="reload" />
                      {/* Refresh */}
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          }
        >
          <Spin spinning={loading}>
            <CustomAgGridTable
              onGridReady={this.onGridReady}
              onColumnMoved={this.saveState}
              onSortChanged={this.saveState}
              onFilterChanged={this.saveState}
              rowDatas={agencies}
              columnDefss={columnDefs}
            />
          </Spin>
          <Pagination
            className="pagination-container cpagination"
            current_page={page}
            total_pages={total_pages}
            onClick={(page) => {
              this.loadAgencies(page);
            }}
          />
        </Card>
        <EditAgencyModal
          history={this.props.history}
          showModal={this.state.edit_agency_modal}
          hideModal={() => this.setState({ edit_agency_modal: false })}
          agency={this.state.agency}
          loadAllAgencies={this.loadAllAgencies.bind(this)}
          updateAgency={this.updateAgency.bind(this)}
        />
        <DeleteInActiveModal
          showModal={this.state.delete_agency_modal}
          hideModal={() => this.setState({ delete_agency_modal: false })}
          agency={this.state.agency}
          loadAllAgencies={this.loadAllAgencies.bind(this)}
          clearSearch={this.clearSearch}
        />
      </div>
    );
  }
}

export default InactiveAgencies;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/inactive-agencies.js